export const CSS_NON_INHERITED_PROPERTIES = new Set([
  'background-attachment',
  'background-color',
  'background-image',
  'background-position',
  'background-repeat',
  'background',
  'border-color',
  'border-style',
  'border-top',
  'border-right',
  'border-bottom',
  'border-left',
  'border-top-color',
  'border-right-color',
  'border-bottom-color',
  'border-left-color',
  'border-top-style',
  'border-right-style',
  'border-bottom-style',
  'border-left-style',
  'border-top-width',
  'border-right-width',
  'border-bottom-width',
  'border-left-width',
  'border-width',
  'border',
  'bottom',
  'clear',
  'clip',
  'content',
  'counter-increment',
  'counter-reset',
  'cue-after',
  'cue-before',
  'cue',
  'display',
  'float',
  'height',
  'left',
  'margin-right',
  'margin-left',
  'margin-top',
  'margin-bottom',
  'margin',
  'max-height',
  'max-width',
  'min-height',
  'min-width',
  'outline-color',
  'outline-style',
  'outline-width',
  'outline',
  'overflow',
  'padding-top',
  'padding-right',
  'padding-bottom',
  'padding-left',
  'padding',
  'page-break-after',
  'page-break-before',
  'page-break-inside',
  'pause-after',
  'pause-before',
  'pause',
  'play-during',
  'position',
  'right',
  'table-layout',
  'top',
  'unicode-bidi',
  'vertical-align',
  'width',
  'z-index',
  'text-decoration',
]);
